import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { useSearchParams } from "react-router-dom";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import CancelIcon from "@mui/icons-material/Cancel";
import galleryIcon from "./../../../../assets/icons/gallery.png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import checkImg from "../../../assets/images/check.png";
import exclamationImg from "./../../../../assets/images/exclamation.png";
import { uploadFiles } from "../../../fileUploader/FileUploader";
import logo from "../../../assets/icons/Go5050.png";
import info from "../../../assets/icons/info2.png";
import location from "../../../assets/icons/pin.png";
import upload from "../../../assets/icons/upload.png";
import "./DeliveryManRegistrationForm.css";
import { uploadOneFiles } from "../../../fileUploader/SingleFileUploader.js";
import Backdrop from "@mui/material/Backdrop";
import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";

function DeliveryManRegistrationForm(props) {
  const restaurantDatas = [
    { id: 1, title: " Local Manager" },
    { id: 2, title: "Waiter" },
    { id: 3, title: "Super Admin" },
  ];
  const [searchParams, setSearchParams] = useSearchParams();
  const [tokenData, setTokenData] = useState({});
  console.log("tokenDataxzxz", tokenData);
  console.log("uiuiu", props);
  const addValue = (props) => {
    console.log(props);
    // setAutoCompleteValue(props)
  };

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  });

  const [filesData, setFilesData] = useState([]);

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      console.log(filesToUpload);
      setFilesData(filesToUpload);
      event.target.value = "";
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  console.log(state.selectedImages);
  console.log(filesData);
  //image test start

  const handleDeleteImage = () => {
    setState({ selectedImages: [] });
  };
  const [radioGetvalue, setradioGetvalue] = React.useState("");

  const handleradioGetvalueChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setradioGetvalue((event.target as HTMLInputElement).value);
    console.log(radioGetvalue);
  };

  //get api start
  const apiAddress = process.env.REACT_APP_SECRET;

  const [dataRows, setDataRows] = React.useState({
    restaurantEmployeeRank: "",
    name: "",
    roleId: "",
    restaurantId: "",
  });

  const [isAlreadyUsed, setIsAlreadyUsed] = React.useState(true);
  const loadData = () => {
    axios
      .get(apiAddress + "/api/EmployeeRolerestaurant/" + searchParams.get("ri"))
      .then((response) => {
        console.log(response.data);
        setDataRows(response.data);
        console.log(dataRows);
        if (dataRows.length > 0) {
          if (!response.data.isActive) {
            setIsAlreadyUsed(false);
          }
        }
      });
  };

  const decodeAndSetToken = () => {
    const token = localStorage.getItem("gotasteadmintoken");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setTokenData(decoded);
    } catch (err) {
      console.error("Invalid token", err);
      localStorage.removeItem("gotasteadmintoken");
      setTokenData(null);
    }
  };

  useEffect(() => {
    console.log("first");
    decodeAndSetToken();
    loadData();
  }, []);
  console.log(dataRows);

  const [value, setValue] = React.useState<Dayjs | null>(dayjs("2022-04-17"));
  var month = parseInt(value.$M + 1);
  var day = value.$y + "-" + month + "-" + value.$D;
  var mydate = new Date(day);

  console.log(mydate);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState(props.email || "");
  const [joiningDate, setJoiningDate] = useState(mydate);
  const [gender, setGender] = useState(radioGetvalue);
  const [contactNumber, setContactNumber] = useState("");
  const [restaurant, setRestaurant] = useState(dataRows.restaurantId);
  const [role, setRole] = useState(dataRows.restaurantEmployeeRank);
  const [imageUrl, setImageUrl] = useState(state.selectedImages);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  //validtion state start
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [contactNumberError, setContactNumberError] = useState(false);
  const [imageUrlError, setImageUrlError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState<string>("");

  const handleLocationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedLocation(e.target.value);
  };
  console.log("Gender" + gender);
  //form data get end
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    joiningDate: mydate,
    gender: radioGetvalue,
    contactNumber: "",
    restaurant: dataRows.restaurantId,
    role: dataRows.roleId,
    imageUrl: state.selectedImages[0],
    password: "",
    confirmPassword: "",
  });

  const firstnameFieldValue = (props) => {
    // data.firstName=props
    setFirstName(props);
    setFirstNameError(false);
  };

  const lastnameFieldValue = (props) => {
    //  data.lastName=props

    setLastName(props);
    setLastNameError(false);
  };
  const usernameFieldValue = (props) => {
    //    data.username=props
    setUsername(props);
    setUsernameError(false);
  };

  const [isValidEmail, setIsValidEmail] = useState(false);
  const validateEmail = (props) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    setIsValidEmail(!emailPattern.test(props));
    return !emailPattern.test(props);
  };

  const emailFieldValue = (props) => {
    // data.email=props
    setEmail(props);
    setEmailError(false);
    validateEmail(email);
  };
  const [validPhoneNumber, SetvalidPhoneNumber] = useState(true);
  const contactFieldValue = (props) => {
    //  data.contactNumber=props
    console.log(props);
    try {
      var test = props / 1;
      console.log(isNaN(test));
      if (isNaN(test)) {
        console.log(props);
        var empty = props.slice(0, -1);
        console.log(empty);
        SetvalidPhoneNumber(false);
        setContactNumber(empty);
      } else {
        SetvalidPhoneNumber(true);
        setContactNumber(props);
      }
    } catch {
      console.log("Error");
    }
  };
  const passswordFieldValue = (props) => {
    //  data.password=props
    setPassword(props);
    setPasswordError(false);
  };
  const confirmpasswordFieldValue = (props) => {
    //  data.confirmpassword=props
    setConfirmPassword(props);
    setConfirmPasswordError(false);
  };
  const restaurantFieldValue = (props) => {
    //  data.restaurant=props
  };
  const roleFieldValue = (props) => {
    //  data.role=props
  };
  const textFieldValue = (props) => {};
  const [success, SetSuccess] = useState(false);
  const onSubmit = () => {
    var valid = true;
    if (firstName.trim() === "") {
      setFirstNameError(true);
      valid = false;
    }
    if (lastName.trim() === "") {
      setLastNameError(true);
      valid = false;
    }
    if (username.trim() === "") {
      setUsernameError(true);
      valid = false;
    }
    if (email.trim() === "") {
      setEmailError(true);
      valid = false;
    }
    if (!email.includes("@")) {
      valid = false;
      toast.error("Email validation Failed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (contactNumber.trim() === "") {
      setContactNumberError(true);
      valid = false;
    }
    if (contactNumber.length != 11) {
      valid = false;
      toast.error("Number can not be more than 11", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (password.trim() === "") {
      setPasswordError(true);
      valid = false;
    }
    if (confirmPassword.trim() === "") {
      setConfirmPasswordError(true);
      valid = false;
    }
    if (password != confirmPassword) {
      valid = false;
      toast.error("Password does not match", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (data.imageUrl == 0) {
      valid = false;
      toast.error("Please upload an image", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    data.imageUrl = state.selectedImages[0];
    console.log(state.selectedImages[0]);
    if (valid) {
      axios({
        method: "post",
        url: apiAddress + "/api/Employee?id=" + searchParams.get("ri"),
        data: data,
      })
        .then((response) => {
          console.log(response);
          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          SetSuccess(true);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.status, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const uploadImg = () => {
    console.log(filesData);

    uploadFiles(filesData);
  };
  const [selectedGender, setSelectedGender] = useState("");

  const handleGenderChange = (event) => {
    setSelectedGender(event.target.value);
  };
  const [selectedDate, setSelectedDate] = useState("");

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
  const date = selectedDate ? new Date(selectedDate).toISOString() : null;
  console.log(date);
  const [obj, setObj] = useState({
    firstName: firstName,
    lastName: lastName,
    username: username,
    email: email,
    DateOfBirth: date,
    contactNumber: contactNumber,
    password: password,
    courierId: props.courierId,
    location: selectedLocation,
    url: props.url,
  });
  const [selectedFile, setSelectedFile] = useState();
  const handleImage = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    var file = event.target.files[0];
    setSelectedFile(file);
  };
  console.log(selectedFile);
  const FileUploader = async (image) => {
    try {
      const resUrl = await uploadOneFiles(image);
      console.log(resUrl);

      return resUrl[0];
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const handleContactNumber = (e) => {
    var num = e.target.value;
    console.log(num);
    setContactNumber(num);
    if (num.length != 10 && num.length != 11) {
      setContactNumberError(true);
    } else {
      setContactNumberError(false);
    }
  };

  const ErrorToast = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  async function handleSubmit() {
    var valid = true;
    obj.firstName = firstName;
    obj.lastName = lastName;
    obj.username = username;
    obj.email = email;
    obj.DateOfBirth = date;
    obj.contactNumber = contactNumber;
    obj.password = password;
    obj.courierId = props.courierId;
    obj.location = selectedLocation;
    obj.url = props.url;

    if (
      lastName == "" ||
      username == "" ||
      email == "" ||
      contactNumber == "" ||
      password == "" ||
      confirmPassword == ""
    ) {
      valid = false;
      ErrorToast("One or more filed is empty");
    } else {
      if (validateEmail(email)) {
        valid = false;
        ErrorToast("Email not valid");
      }
    }

    if (contactNumber.length != 10 && contactNumber.length != 11) {
      valid = false;
      ErrorToast("Number must be of 10 or 11 digits");
    }
    if (password != confirmPassword) {
      valid = false;
      ErrorToast("Password does not match");
    }
    if (selectedDate == "") {
      valid = false;
      ErrorToast("Date of birth is required");
    }

    if (valid) {
      setIsRegistering(true);
      try {
        const response = await axios.post(
          `${apiAddress}/api/DeliveryMan/DeliveryManRegister`,
          obj,
        );

        console.log("mkmk", response.data);
        toast.success(response.data);
        setTimeout(() => {
          resetForm();
          // Optional: close modal after success
          handleClose();
        }, 1000);
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      } finally {
        setIsRegistering(false);
      }
    }
  }

  const [isAgreementChecked, setIsAgreementChecked] = useState(false);

  // Function to handle checkbox change
  const handleAgreementCheckboxChange = (event) => {
    setIsAgreementChecked(event.target.checked);
  };

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    props.modalClose(open);
  };

  const today = new Date().toISOString().split("T")[0];
  const [maxDate, setMaxDate] = useState(today);

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setUsername("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setContactNumber("");
    setSelectedDate("");
    setSelectedLocation("");
  };

  return (
    <>
      <Dialog maxWidth="lg" open={props.open} onClose={handleClose}>
        <DialogContent>
          <div className="d-flex justify-content-between LogoLoginDiv"></div>

          <div className="formPadding">
            <div className="d-flex justify-content-center">
              <h2>Register for delivery man</h2>
            </div>
            <p>Join our community of savers!</p>
            <hr />
            {/* <form onSubmit={handleSubmit}> */}
            <div className="d-flex justify-content-between">
              <div className="formFieldWidth">
                <label className="form-label">First name</label>
                <input
                  className="form-control "
                  type="text"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
              <div className="formFieldWidth">
                <label className="form-label">Last name</label>
                <input
                  className="form-control "
                  type="text"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="d-flex justify-content-between mt-3">
              <div className="formFieldWidth">
                <label className="form-label">Username</label>
                <input
                  className="form-control "
                  type="text"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="formFieldWidth">
                <label className="form-label">Date of birth</label>
                <input
                  className="form-control "
                  type="date"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={selectedDate}
                  max={maxDate}
                  onChange={handleDateChange}
                />
              </div>
            </div>

            <div className="d-flex justify-content-between mt-3">
              <div className="formFieldWidth">
                <label className="form-label">Contact number</label>
                <input
                  className="form-control "
                  type="number"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={contactNumber}
                  onChange={handleContactNumber}
                  required
                />
                {contactNumberError && (
                  <span style={{ color: "red" }}>
                    Number must be of 10 or 11 digits
                  </span>
                )}
              </div>
            </div>

            <div className="mb-3 mt-3">
              <label htmlFor="exampleFormControlInput1" className="form-label">
                Email address
              </label>
              <input
                type="email"
                className="form-control"
                id="exampleFormControlInput1"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled
                readOnly
              />
            </div>

            <div className="d-flex justify-content-between mt-3">
              <div className="formFieldWidth">
                <label className="form-label">Password</label>
                <input
                  className="form-control "
                  type="password"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="formFieldWidth">
                <label className="form-label">Confirm password</label>
                <input
                  className="form-control "
                  type="password"
                  aria-label="default input example"
                  style={{ width: "100%" }}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* <div className="ImageTitle mt-2">
              <p>Image</p>
            </div>
            <div className="btn  mt-2 RegisteruploadButton">
              <input
                type="file"
                className=""
                id="img"
                accept=".img, .jpg, .jpeg, .png"
                onChange={handleImage}
              ></input>
              <img src={upload} alt="" />
              <label htmlFor="img">Upload</label>
            </div>
            {selectedFile && <p>{selectedFile.name}</p>} */}

            <div className="input-group mb-3 mt-2">
              <button
                className="btn "
                type="button"
                style={{
                  marginRight: "5px",
                  backgroundColor: "#78a8c4",
                  color: "white",
                }}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={location}
                    alt="locatiopn"
                    style={{ width: "1rem", height: "1rem" }}
                  />
                  Get Location
                </div>
              </button>

              <select
                className="form-select"
                id="inputGroupSelect03"
                aria-label="Select location"
                value={selectedLocation}
                onChange={handleLocationChange}
              >
                <option value="" disabled>
                  Find your location
                </option>
                <option value="London">London</option>
                <option value="Manchester">Manchester</option>
                <option value="Liverpool">Liverpool</option>
                {/* Add more options as needed */}
              </select>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                checked={isAgreementChecked}
                onChange={handleAgreementCheckboxChange}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                I accept the{" "}
                <a href="#" style={{ textDecoration: "none" }}>
                  terms and conditions
                </a>
              </label>
            </div>
            {/* <button
              className="btn"
              style={{ backgroundColor: "#78a8c4", color: "white" }}
              onClick={handleSubmit}
              disabled={!isAgreementChecked}
            >
              {" "}
              Register
            </button> */}
            <button
              className="btn"
              style={{
                backgroundColor: "#78a8c4",
                color: "white",
                minWidth: "140px",
              }}
              onClick={handleSubmit}
              disabled={!isAgreementChecked || isRegistering}
            >
              {isRegistering ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Registering...
                </>
              ) : (
                "Register"
              )}
            </button>

            {/* </form> */}
          </div>
          <div className={`${success ? "successModal-background-blur" : ""}`}>
            <div
              className={`${success ? "Successmodal custom-registerForm loginCardKYC" : " d-none"}`}
            >
              <div
                className="d-flex align-items-center"
                style={{ flexDirection: "column", gap: "10px", width: "27rem" }}
              >
                <img src={checkImg} alt="" style={{ width: "5rem" }} />
                <h2>Successfully registered </h2>
                <p>Please check your email to verify yourself</p>
                <h6
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.location.href = "/login";
                  }}
                >
                  Go to login
                </h6>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeliveryManRegistrationForm;
